import { Stack } from "@fluentui/react";
import React, { useState } from "react";
import Share from "./Share";
import Save from "./Save";
import AcceptAllChanges from "./AcceptAllChanges";
import RejectAllChanges from "./RejectAllChanges";

const stackToken = {
  childrenGap: 10,
};
const stackStyles = {
  root: {},
};

const stackItemStyle = {
  root: {
    minWidth: "60%",
  },
};

export default function CompareButtonStack({
  setLoading,
  refreshDocument,
  setRefreshDocument,
  status,
  setStatus,
  isRedlined,
  url,
}) {

  const [selected, setSelected] = useState("Save & Share");
  const [hovered, setHovered] = useState("");
  return (
    <Stack tokens={stackToken} styles={stackStyles}>
      <Stack.Item align="center" styles={stackItemStyle}>
        <Share
          selected={selected}
          setSelected={setSelected}
          hovered={hovered}
          setHovered={setHovered}
          heading={"Save & Share"}
        />
      </Stack.Item>
      {!status && isRedlined ? (
        <>
          <Stack.Item align="center" styles={stackItemStyle}>
            <AcceptAllChanges
              setStatus={setStatus}
              loading={setLoading}
              selected={selected}
              setSelected={setSelected}
              hovered={hovered}
              setHovered={setHovered}
            />
          </Stack.Item>
          <Stack.Item align="center" styles={stackItemStyle}>
            <RejectAllChanges
              setStatus={setStatus}
              loading={setLoading}
              selected={selected}
              setSelected={setSelected}
              hovered={hovered}
              setHovered={setHovered}
            />
          </Stack.Item>
        </>
      ) : null}
      <Stack.Item align="center" styles={stackItemStyle}>
        <Save
          refreshDocument={refreshDocument}
          setRefreshDocument={setRefreshDocument}
          setLoading={setLoading}
          selected={selected}
          setSelected={setSelected}
          hovered={hovered}
          setHovered={setHovered}
        />
      </Stack.Item>
    </Stack>
  );
}
